import AlternateEmailIcon from "@mui/icons-material/AlternateEmail";
import IconInput from "./IconInput";

export default function Email(props: any) {
  return <IconInput type="email" startComponent={<AlternateEmailIcon />} {...props} />;
}
